import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { Modal } from '@fiverr-private/orca';
import { CLICKED_ON_LEAVE_POP_UP_MESSAGE, CLICKED_ON_STAYING_IN_POP_UP_MESSAGE } from '../../constants/biEvents';
import { useReporting } from '../../context/contexts/reporting';

const ConfirmationModal = ({ isOpen, onClose = noop, onConfirmation = noop, className }) => {
    const { sendBiEvent, sendMixpanelEvent } = useReporting();

    const onLeave = () => {
        const event = { type: CLICKED_ON_LEAVE_POP_UP_MESSAGE };

        sendBiEvent(event);
        sendMixpanelEvent(event);
        onConfirmation();
    };

    const onStay = () => {
        const event = { type: CLICKED_ON_STAYING_IN_POP_UP_MESSAGE };

        sendBiEvent(event);
        sendMixpanelEvent(event);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} overlayClassName={className}>
            <Modal.Header>
                <I18n k="send_message.close_confirmation.header"/>
            </Modal.Header>
            <Modal.Body>
                <I18n k="send_message.close_confirmation.body"/>
            </Modal.Body>
            <Modal.Footer>
                <Button intent="secondary" onClick={onStay}>
                    <I18n k="send_message.close_confirmation.stay"/>
                </Button>
                <Button className="m-l-12" onClick={onLeave}>
                    <I18n k="send_message.close_confirmation.leave"/>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    className: PropTypes.string
};

export default ConfirmationModal;
